module.exports = __webpack_public_path__ + "images/google-icon-0eb8078198b32ac9d48f60dc38d16bc3.png";